var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{active: ['ar', 'ur', 'ps','fa','he'].includes(_vm.$i18n.locale)},attrs:{"id":"app"}},[_c('router-view'),_c('footer',{staticClass:"game-footer"},[_c('strong',[_vm._v(" "+_vm._s(_vm.$t("disclaimer"))+" ")]),_vm._v(" "+_vm._s(_vm.$t("disclaimer_message"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }